export default __webpack_public_path__ + "static/healthCareBgMb-d09324fc57fdee87b959cfa4d1271c55.png";